<script lang="ts">
  import { onMount } from "svelte";
  import WishlistItem from "./WishlistItem.svelte";
  import wishlist from "../../store/wishlist";
  import lang from "../../lang/language";
  import Button from "../controls/Button.svelte";

  export let hide: Function;

  onMount(() => wishlist.init());
</script>

<div class="boxer thin-scrollbar">
  <div class="boxer-inner thin-scrollbar" style="overflow: auto">
    {#if $wishlist.length > 0}
      {#each $wishlist as item}
        <WishlistItem wishlist={item} remove={() => wishlist.add(item)} />
      {/each}
    {:else}
      <div class="row text-center" style="padding-top: 50%">
        <i style="font-size: 40px;color: grey" class="far fa-sad-tear" />
        <h3 style="color:grey;margin-left: 10px">{lang.wishlist_empty}</h3>
      </div>
    {/if}
  </div>
  <div class="row text-center" style="padding-top: 10px">
    {#if $wishlist.length > 0}
      <Button
        primary
        classList={["redirect-button"]}
        onClick={wishlist.goToCABS}
      >
        {lang.check_availability}
      </Button>
    {/if}
    <Button secondary classList={["close-button"]} onClick={hide}>
      {lang.close}
    </Button>
  </div>
</div>

<style>
  .boxer {
    overflow: auto;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: calc(75vh - 40px);
    padding: 10px 5px 3px 5px;
    box-sizing: border-box;
  }

  .boxer-inner {
    flex: 1;
  }

  :global(.close-button),
  :global(.redirect-button) {
    height: 35px;
    line-height: 5px;
    text-align: left;
  }

  :global(.close-button) {
    width: 45%;
  }
</style>
